const getters = {
    sidebar: state => state.app.sidebar,
    size: state => state.app.size,
    device: state => state.app.device,
    user: state => state.auth.user,
    loggedIn: state => state.auth.status.loggedIn,
    // token: state => state.user.token,
    // avatar: state => state.user.avatar,
    // name: state => state.user.name,
    // introduction: state => state.user.introduction,
    roles: state => state.auth.roles,
    permissionRoutes: state => state.permission.routes,
    shopRoutes: state => state.permission.shoproutes,
    // errorLogs: state => state.errorLog.logs
};
export default getters;
